import { render } from "./classDetail.vue?vue&type=template&id=43cfb0e3&scoped=true"
import script from "./classDetail.vue?vue&type=script&lang=js"
export * from "./classDetail.vue?vue&type=script&lang=js"

import "./classDetail.vue?vue&type=style&index=0&id=43cfb0e3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43cfb0e3"]])

export default __exports__